import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

class ShowNextPage extends React.Component {
  click = () => {
    const {
      to,
      history: { push },
    } = this.props;
    push(to);
  };

  render() {
    const { text, t } = this.props;
    return (
      <div className="load-more-main-container">
        <button className="show-next-page-container" onClick={this.click}>
          {text || t("TWBC0001_more")}
        </button>
      </div>
    );
  }
}

ShowNextPage.propTypes = {
  to: PropTypes.object.isRequired,
  text: PropTypes.string,
};

ShowNextPage.defaultProps = {
  text: "",
};

export default withRouter(withTranslation()(ShowNextPage));
